import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase';

const DAY_MS = 24 * 60 * 60 * 1000;

function isoDaysAgo(n) {
    return new Date(Date.now() - n * DAY_MS).toISOString().slice(0, 10);
}

/**
 * Subscribe to metrics_facility_daily/* for the last `days` days where
 * facility_id == facilityId, ordered by date desc.
 */
export function useFacilityDaily(facilityId, days = 30) {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(Boolean(facilityId));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!facilityId) {
            setLoading(false);
            setDocs([]);
            return undefined;
        }
        setLoading(true);
        setError(null);
        const startDate = isoDaysAgo(days);
        const q = query(
            collection(db, 'metrics_facility_daily'),
            where('facility_id', '==', facilityId),
            where('date', '>=', startDate),
            orderBy('date', 'desc'),
        );
        const unsubscribe = onSnapshot(
            q,
            (snap) => {
                const next = [];
                snap.forEach((d) => next.push(d.data()));
                setDocs(next);
                setLoading(false);
            },
            (err) => {
                setError(err);
                setLoading(false);
            },
        );
        return unsubscribe;
    }, [facilityId, days]);

    return { docs, loading, error };
}
